import {useMemo, useRef} from 'react';

import {
  toWeaveQueryPanelEventData,
  trackWeaveQueryPanelEvent,
} from '../../../../services/analytics/weaveQueryPanelEvents';
import {usePanelContext} from '../PanelContext';

/**
 * Records panel2 interactions, tagged with a link to the panel they happened in.
 */
export function useEventRecorder(panelID: string) {
  const {panelAnalytics, path} = usePanelContext();

  const analyticsRef = useRef(panelAnalytics);
  // oxlint-disable-next-line react/refs
  analyticsRef.current = panelAnalytics;
  const pathRef = useRef(path);
  // oxlint-disable-next-line react/refs
  pathRef.current = path;

  return useMemo(
    () => (action: string, payload?: Record<string, unknown>) => {
      const analytics = analyticsRef.current;
      trackWeaveQueryPanelEvent(
        toWeaveQueryPanelEventData({
          action: `${panelID}.${action}`,
          panelLink: analytics?.getLink() ?? window.location.href,
          page: analytics?.page ?? 'weave',
          payload: {...payload, panelPath: pathRef.current.join('.')},
        })
      );
    },
    [panelID]
  );
}

export type EventRecorder = ReturnType<typeof useEventRecorder>;
